import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import EmptyList from "go-core/components/EmptyList";
import { LoadingContainer } from "go-core/components/Loading";
import { AdminOrganizationUserApi } from "../../../../../../../services/Api/Admin/adminTypes";
import { OrganizationApplicationApi } from "../../../../../../../services/Api/types";
import { OrganizationPreviewRequests } from "../../services/types";
import OrganizationUserCard from "../OrganizationUserCard";

interface Props {
	organizationId: number;
	applications: OrganizationApplicationApi[];
	requests: OrganizationPreviewRequests;
}

const UsersTabPreview = ({ organizationId, applications, requests }: Props) => {
	const [users, setUsers] = useState<AdminOrganizationUserApi[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const { addFlash } = useFlash();
	const { t } = useTranslation("admin");

	const fetchUsers = async () => {
		setLoading(true);
		try {
			const res = await requests.users(organizationId);
			setUsers(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
		setLoading(false);
	};

	useEffect(() => {
		fetchUsers();
	}, []);

	if (loading) return <LoadingContainer />;

	return (
		<>
			{users.length > 0 ? (
				<>
					<div className="row mb-n2 g-2">
						{users.map((user, index) => {
							return (
								<div className="col-md-6" key={`user-${index}`}>
									<OrganizationUserCard
										requests={requests}
										organizationId={organizationId}
										user={user}
										applications={applications}
									/>
								</div>
							);
						})}
					</div>
				</>
			) : (
				<Card>
					<Card.Body>
						<EmptyList
							title={t("lib:common.word.users")}
							description={t("modules.organization.field.no_users.description")}
						/>
					</Card.Body>
				</Card>
			)}
		</>
	);
};
export default UsersTabPreview;
